import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  BasicDetailWantToSell,
  Currency,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import { useTranslation } from "react-i18next";
import { Label } from "../../../Common/Label/Label";
import "react-intl-tel-input/dist/main.css";
import HelperService from "../../../../Services/HelperService";
import WebService from "../../../../Services/WebService";
import { toast } from "react-toastify";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import {
  ACCOUNT_TYPE_API,
  DROPDOWNTYPES,
} from "../../../../assets/constants/constants";
import {
  dropdownApiNewcall,
  getProfileJourneyInfo,
  isMobileNumberValid,
  getCountryListAPiCall,
} from "../../../../Services/CommonFunction";
import PhoneInput1 from "../../../PhoneInput/PhoneInput1";
import { useLocation } from "react-router-dom";
import Select from "react-dropdown-select";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import ErrorComponent from "../../../Common/ErrorComponent";
import CurrencySelect from "../../../Common/CurrencyDropDown/CurrencyDropdwon";
import { useDispatch, useSelector } from "react-redux";
import { storePrefferedCurrency } from "../../../../config/action";
import { MdVerifiedUser } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import GoogleAddressSearch from "../../../GoogleAddressSearch/GoogleAddressSearch";
import PasswordInput, { validatePassword } from "../../../Common/PasswordInput";
import Select1 from "react-select";
import { isWarning } from "../../Helper";


interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from?: string;
  fields_to_improve?: any;
}
const types = [DROPDOWNTYPES.BUSINESS_INDUSTRY, DROPDOWNTYPES.OWNERSHIP_TYPE];
const BasicDetailsWantToSell = ({
  handleNext,
  impIds,
  from,
  fields_to_improve,
}: PropsData) => {
  const [account_type, setAccount_type] = useState("");
  const [emailVerifiedAt, setEmailVerifiedAt] = useState(false);
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  const { t } = useTranslation();
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const selectedCurrency: Currency = useSelector(
    (state: any) => state?.items?.storedPrefferedCurrency,
  );
  const controlRef = useRef<HTMLDivElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef.current) {
      observer.observe(controlRef.current);
    }

    return () => observer.disconnect();
  }, [menuOpen]);

  const [isManualAddress, setIsManualAddress] = useState(false);
  const [basicDetails, setBasicDetails] = useState<BasicDetailWantToSell>({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    company_name: "",
    dial_code: "",
    country_code: "",
    mobile_number: "",
    login_type: impIds?.login_type?.toUpperCase() ?? "",
    account_type: impIds?.account_type?.toUpperCase() ?? "",
    brief_about_business: "",
    vision_mission: "",
    business_industry: [],
    business_listing_title: "",
    company_website: "",
    ownership_type: "",
    reason_for_sale: "",
    strength_differentiators: "",
    year_of_establishment: "",
    city: "",
    country: "",
    preferred_currency: selectedCurrency ? selectedCurrency?.code : "",
    ownership_type_other: "",
    pincode: "",
    location: "",
    login_field: "NONE",
    social_id: "",
  });

  let locationVar = useLocation();
  const socialData = locationVar?.state?.social_data;
  const [apiCallTriggered, setAPICallTriggered] = useState(false);
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);

  useEffect(() => {
    if (socialData) {
      setBasicDetails((prev: BasicDetailWantToSell) => ({
        ...prev,
        // split name if needed
        first_name: socialData?.name?.split(" ")[0] || "",
        last_name: socialData?.name?.split(" ").slice(1).join(" ") || "",

        email: socialData?.email || "",

        // optional (if you store provider info)
        login_field: socialData?.provider,
        social_id: socialData?.provider_id,
      }));

      // optionally mark email verified
      // setEmailVerifiedAt(true);
    }
  }, [socialData]);

  const stored_password = sessionStorage.getItem("temp_password");
  const [countryOptions, setCountryOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    getCountryListAPiCall("")
      .then((data: any) => {
        if (Array.isArray(data)) {
          const formatted = data.map((item: any) => ({
            label: item?.title || item?.name || "",
            value: item?.title || item?.name || "",
          }));
          setCountryOptions(formatted);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (impIds?.uuid) {
      getBasicDetails();
    }
    loadDropdowns();
  }, []);

  useEffect(() => {
    setAccount_type(impIds?.account_type);
  }, [impIds?.account_type]);
  let location = useLocation();
  let status = location?.state?.disable;
  let dispatch = useDispatch();
  const getBasicDetails = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `get-detail/${impIds?.uuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          let companyInfo = res?.info?.companies;
          let businessInfo = res?.info?.business_info;
          setBasicDetails((prevBasicDetails: BasicDetailWantToSell) => ({
            ...prevBasicDetails,
            first_name: info?.first_name,
            last_name: info?.last_name,
            company_name: companyInfo?.company_name,
            mobile_number: info?.mobile_number ?? "",
            dial_code: info?.dial_code,
            city: businessInfo?.entrepreneur_business_details?.city,
            country: businessInfo?.entrepreneur_business_details?.country,
            email: info?.email,
            location: businessInfo?.entrepreneur_business_details?.location,
            pincode: businessInfo?.entrepreneur_business_details?.pincode,
            ownership_type_other:
              businessInfo?.entrepreneur_business_details?.ownership_type_other,
            brief_about_business:
              businessInfo?.entrepreneur_business_details?.brief_about_business,
            vision_mission:
              businessInfo?.entrepreneur_business_details?.vision_mission,
            business_industry:
              businessInfo?.entrepreneur_business_details?.business_industry
                ?.length > 0
                ? businessInfo?.entrepreneur_business_details?.business_industry.map(
                  (item: any) => ({
                    title: item?.title,
                    other: item?.other,
                  }),
                )
                : [],
            business_listing_title:
              businessInfo?.entrepreneur_business_details
                ?.business_listing_title,
            company_website:
              businessInfo?.entrepreneur_business_details?.company_website,
            ownership_type:
              businessInfo?.entrepreneur_business_details?.ownership_type,
            reason_for_sale:
              businessInfo?.entrepreneur_business_details?.reason_for_sale,
            strength_differentiators:
              businessInfo?.entrepreneur_business_details
                ?.strength_differentiators,
            year_of_establishment:
              businessInfo?.entrepreneur_business_details
                ?.year_of_establishment,
            preferred_currency: info?.preferred_currency,
            password:
              from !== "REVIEW" && impIds?.business_uuid
                ? stored_password || ""
                : "",
            mobile_verified_at: info?.mobile_verified_at,
          }));
          if (info?.currency) {
            dispatch(storePrefferedCurrency(info?.currency));
          }

          setEmailVerifiedAt(res?.info?.email_verified_at ?? false);
          // setMobileVerifiedat(res?.info?.mobile_verified_at ?? false);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const CustomInput = React.forwardRef(({ value, onClick }: any, ref: any) => (
    <div className="input-group w-100" onClick={onClick} ref={ref}>
      <input
        type="text"
        className="form-control"
        value={value}
        readOnly
        placeholder="Select date"
      />
      <span className="input-group-text bg-white">
        <FaCalendarAlt />
      </span>
    </div>
  ));
  const handleArrayValueChange = (value: any[], key: string) => {
    setBasicDetails((prevDetails: BasicDetailWantToSell) => ({
      ...prevDetails,
      [key]: Array.isArray(prevDetails[key as keyof BasicDetailWantToSell])
        ? value.map((item) => ({ title: item?.value, other: item?.other }))
        : value[0]?.value,
    }));
  };
  const handleChange = (name: string, value: string) => {
    // const { name, value } = e.target;
    if (name === "brief_about_business" || name === "vision_mission") {
      if (value?.length > 700) return;
    }
    setBasicDetails((prevBasicDetails: BasicDetailWantToSell) => ({
      ...prevBasicDetails,
      [name]: value,
    }));
  };
  const handleSaveBasicDetails = (flag: boolean) => {
    if (
      HelperService?.checkFormEmptyFields(basicDetails, [
        "login_type",
        "company_name",
        "ownership_type_other",
        "company_website",
        "pincode",
        "password",
        "strength_differentiators",
        "mobile_number",
        "social_id",
        "mobile_verified_at",
        "brief_about_business",
        "vision_mission",
        "company_website",
        "business_listing_title",
        "company_website",
        "reason_for_sale",
        "strength_differentiators",
        "year_of_establishment",
      ]) ||
      (basicDetails.ownership_type === "Other" &&
        !basicDetails.ownership_type_other) ||
      (basicDetails.business_industry.length > 0 &&
        basicDetails.business_industry[0].title === "Other" &&
        !basicDetails.business_industry[0].other) ||
      (basicDetails?.company_website &&
        !HelperService.checkWebUrl(basicDetails?.company_website))
    ) {
      setErrorFlag(true);
      return;
    }
    if (
      (!basicDetails?.password || !validatePassword(basicDetails?.password)) &&
      from !== "REVIEW" &&
      from !== "FROM_PROFILE_ANALYSIS"
    ) {
      setErrorFlag(true);
      return;
    }
    if (!HelperService.isValidEmail(basicDetails.email)) {
      setErrorFlag(true);
      return;
    }

    setErrorFlag(false);

    if (impIds?.business_uuid) {
      handleUpdateBasicDetailsApiCall(flag);
    } else {
      handleSaveBasicDetailsApiCall(flag);
    }
  };
  const { FCMDeviceToken } = useSelector((state: any) => state.items);

  const handleSaveBasicDetailsApiCall = (flag: boolean) => {
    let updatedata = {
      ...basicDetails,
      mobile_number: basicDetails?.mobile_number
        ? HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        )
        : null,
      device_token: FCMDeviceToken,
    };
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);
    return WebService.postAPI({
      action: `basic-detail/${account_type.toLocaleLowerCase()}`,
      body: updatedata,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(
            res,
            basicDetails?.email,
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
            // res?.mobile_verification_required,
            res?.email_verification_required,
            basicDetails?.country_code,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };
  const handleUpdateBasicDetailsApiCall = (flag: boolean) => {
    let updatedata = {
      ...basicDetails,
      mobile_number: basicDetails?.mobile_number
        ? HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        )
        : null,
    };

    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);

    const accountTypeKey = account_type as keyof typeof ACCOUNT_TYPE_API;
    return WebService.putAPI({
      action: `basic-detail/want-to-sell/${impIds?.uuid}/${impIds?.business_uuid}`,
      body: updatedata,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          if (
            // !res?.mobile_verification_required &&
            !res?.email_verification_require
          )
            toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(
            res,
            basicDetails?.email,
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
            // res?.mobile_verification_required,
            res?.email_verification_required,
            basicDetails?.country_code,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };

  const handlePhoneChange = (value: any, countryData: any) => {
    setBasicDetails((prevBasicDetails: BasicDetailWantToSell) => ({
      ...prevBasicDetails,
      dial_code: countryData?.dialCode,
      mobile_number: value,
      country_code: countryData?.iso2,
    }));
  };

  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("want-to-sell", types); // types is an array of expected keys
      const formattedData: Record<string, any[]> = {};

      types.forEach((type) => {
        const items = res[type];

        if (Array.isArray(items)) {
          if (type === "business_industry") {
            const grouped = items.reduce((acc: Record<string, any[]>, item) => {
              const groupName = item.group || "Other";
              if (!acc[groupName]) acc[groupName] = [];
              acc[groupName].push({
                label: item.title,
                value: item?.is_other === 1 ? "Other" : item.title,
              });
              return acc;
            }, {});

            formattedData[type] = Object.entries(grouped).map(
              ([group, options]) => ({
                label: group,
                options,
              }),
            );
          } else {
            formattedData[type] = items.map((item) => ({
              label: item.title,
              value: item.title,
            }));
          }
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }
  const handleYearChange = (date: Date | null) => {
    if (date) {
      setBasicDetails((prev) => ({
        ...prev,
        year_of_establishment: date.getFullYear().toString(),
      }));
    }
  };

  return (<>
    <div className="login-form w-100 px-0 position-relative">
      {loader ? <CompoLoader /> : null}
      <div className="custom-title my-auto font-bold mb-2">
        {t("Register.Basic_Details")}
      </div>
      <p className="font-14 mb-1">{t("Register.basic_details_msg")}</p>
      <CommonScrollbar height={"60vh"}>
        <div className="p-2 me-2">
          <div className="mb-2 d-flex gap-2">
            <div className="w-50">
              <RequiredLabel isRequired={true}>First Name</RequiredLabel>

              <Form.Control
                type="text"
                className={
                  (!basicDetails?.first_name && skipButtonClicked) ||
                    isWarning(fields_to_improve, "first_name")
                    ? "warning-field"
                    : ""
                }
                placeholder="First Name"
                name="first_name"
                disabled={from === "REVIEW" || status}
                value={basicDetails?.first_name}
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
              />
              {!skipButtonClicked && errorFlag && !basicDetails?.first_name && (
                <Label title="Please enter first name" modeError={true} />
              )}
            </div>
            <div className="w-50">
              <RequiredLabel isRequired={true}>Last Name</RequiredLabel>

              <Form.Control
                type="text"
                placeholder="Last Name"
                name="last_name"
                disabled={from === "REVIEW" || status}
                value={basicDetails?.last_name}
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
                className={
                  (!basicDetails?.last_name && skipButtonClicked) ||
                    isWarning(fields_to_improve, "last_name")
                    ? "warning-field"
                    : ""
                }
              />
              {errorFlag && !skipButtonClicked && !basicDetails?.last_name && (
                <Label title="Please enter last name" modeError={true} />
              )}
            </div>
          </div>

          <div className="mb-2">
            <RequiredLabel isRequired={true}>
              Registered Business Name
            </RequiredLabel>
            <Form.Control
              type="text"
              placeholder="Company Name"
              name="company_name"
              value={basicDetails?.company_name}
              className={
                (!basicDetails?.company_name && skipButtonClicked) ||
                  isWarning(fields_to_improve, "company_name")
                  ? "warning-field"
                  : ""
              }
              onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
            />
            {!skipButtonClicked && errorFlag && !basicDetails?.company_name && (
              <Label
                title={t("Register.please_enter_company_name")}
                modeError={true}
              />
            )}
          </div>
          <div className="w-100 d-flex gap-1 mb-2">
            <div className="w-50">
              <RequiredLabel isRequired={false}>
                Business Listing Title
              </RequiredLabel>
              <Form.Control
                type="text"
                placeholder="Business Listing Title"
                name="business_listing_title"
                value={basicDetails?.business_listing_title}
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
                className={
                  isWarning(fields_to_improve, "business_listing_title")
                    ? "warning-field"
                    : ""
                }
              />
              {/* {errorFlag && !basicDetails?.business_listing_title && (
                <Label
                  title="Please enter business listing title"
                  modeError={true}
                />
              )} */}
            </div>
            <div className="w-50">
              <RequiredLabel isRequired={true}>
                Preferred Currency
              </RequiredLabel>
              <CurrencySelect
                isDisabled={from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"}
                className={
                  (!basicDetails?.preferred_currency && skipButtonClicked) ||
                    isWarning(fields_to_improve, "preferred_currency")
                    ? "warning-field"
                    : ""
                }
                onChange={(value: any) => {
                  if (value?.value) {
                    setBasicDetails((prev: BasicDetailWantToSell) => ({
                      ...prev,
                      preferred_currency: value?.value,
                    }));
                  }
                }}
              />
            </div>
          </div>

          <div className="d-flex gap-1  ">
            <div className="mb-2 col-lg-6 w-50">
              <div className="d-flex justify-content-between">
                <RequiredLabel isRequired={false}>Mobile Number</RequiredLabel>
                {basicDetails?.mobile_verified_at && (
                  <div className="d-flex gap-1 justify-content-end">
                    <MdVerifiedUser color="green" className="" />
                    <span className="font-12 text-success">Verified</span>
                  </div>
                )}
              </div>

              <PhoneInput1
                value={basicDetails?.mobile_number}
                errorFlag={errorFlag}
                disabled={
                  from === "REVIEW" ||
                  from === "FROM_PROFILE_ANALYSIS" ||
                  status
                }
                dial_code={basicDetails?.dial_code}
                handlePhoneNumberChange={(value: any, countryData: any) =>
                  handlePhoneChange(value, countryData)
                }
                className={
                  isWarning(fields_to_improve, "mobile_number")
                    ? "warning-field"
                    : ""
                }
              />
              {errorFlag &&
                // !basicDetails?.mobile_number ||
                basicDetails.mobile_number &&
                !isMobileNumberValid(
                  basicDetails?.mobile_number,
                  basicDetails?.dial_code,
                ) && (
                  <Label
                    title="Please enter valid mobile number"
                    modeError={true}
                  />
                )}
            </div>
            <div className="mb-2 col-lg-6" style={{ marginRight: "2px" }}>
              <div className="d-flex justify-content-between">
                <RequiredLabel isRequired={true}>
                  Official Email ID
                </RequiredLabel>
                {basicDetails?.mobile_number &&
                  basicDetails?.mobile_verified_at && (
                    <div className="d-flex gap-1 justify-content-end">
                      <MdVerifiedUser color="green" className="" />
                      <span className="font-12 text-success">Verified</span>
                    </div>
                  )}
              </div>

              <Form.Control
                type="text"
                placeholder={t("Register.enter_email")}
                name="email"
                disabled={
                  from === "REVIEW" ||
                  from === "FROM_PROFILE_ANALYSIS" ||
                  status
                }
                className={
                  (!basicDetails?.email && skipButtonClicked) ||
                    isWarning(fields_to_improve, "email")
                    ? "warning-field"
                    : ""
                }
                value={basicDetails?.email}
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
              />
              {((!skipButtonClicked && errorFlag && !basicDetails?.email) ||
                (errorFlag &&
                  basicDetails?.email &&
                  !HelperService.isValidEmail(basicDetails?.email))) && (
                  <Label title={t("Register.invalid_email")} modeError={true} />
                )}
            </div>
          </div>
          {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
            <>
              <PasswordInput
                label="Password"
                name="password"
                value={basicDetails?.password || ""}
                onChange={(e) => handleChange(e.target.name, e?.target?.value)}
                required
                className={
                  !basicDetails?.password && skipButtonClicked
                    ? "warning-field"
                    : ""
                }
                strongValidate
              />
              {!skipButtonClicked && !basicDetails?.password && errorFlag && (
                <Label title="Please enter password" modeError={true} />
              )}
            </>
          )}

          <div className="mb-2 d-flex gap-1 justify-content-between ">
            <div className="w-100">
              <GoogleAddressSearch
                label={<RequiredLabel isRequired={true}>Head Quarter Location</RequiredLabel>}
                mode="address"
                value={basicDetails?.location}
                onManualToggle={(isManual: boolean) => setIsManualAddress(isManual)}
                onSelect={(
                  address: string,
                  place: google.maps.places.PlaceResult,
                  geo: { lat: number | null; lng: number | null },
                ) => {
                  handleChange("location", address);
                  handleChange(
                    "latitude",
                    geo?.lat ? geo?.lat?.toString() : "",
                  );
                  handleChange(
                    "longitude",
                    geo?.lng ? geo?.lng?.toString() : "",
                  );
                  let city = "";
                  let state = "";
                  let country = "";
                  let pincode = "";

                  if (place.address_components) {
                    for (let component of place.address_components) {
                      if (component.types.includes("locality")) {
                        city = component.long_name;
                      }
                      if (
                        component.types.includes("administrative_area_level_1")
                      ) {
                        state = component.long_name;
                      }
                      if (component.types.includes("country")) {
                        country = component.long_name;
                      }
                      if (component.types.includes("postal_code")) {
                        pincode = component.long_name;
                      }
                    }
                  }
                  handleChange("pincode", pincode);
                  handleChange("city", city);
                  handleChange("state", state);
                  handleChange("country", country);
                }}
                className={
                  (!basicDetails?.location && skipButtonClicked) ||
                    isWarning(fields_to_improve, "location")
                    ? "warning-field"
                    : ""
                }
              />

              <ErrorComponent
                title="Please enter location"
                flag={errorFlag && !skipButtonClicked}
                isArray={false}
                data={basicDetails?.location}
              />
            </div>
          </div>
          <div className="d-flex w-100 gap-1 mb-1">
            <div className="w-50">
              <RequiredLabel isRequired={true}>City</RequiredLabel>

              <Form.Control
                type="text"
                name="city"
                placeholder="Enter city"
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
                className={
                  (!basicDetails?.city && skipButtonClicked) ||
                    isWarning(fields_to_improve, "city")
                    ? "warning-field"
                    : ""
                }
                value={basicDetails?.city}
              />
              <ErrorComponent
                title="Please enter city"
                flag={errorFlag && !skipButtonClicked}
                isArray={false}
                data={basicDetails?.city}
              />
            </div>

            <div className="w-50">
              <RequiredLabel isRequired={true}>
                Country of Registration
              </RequiredLabel>
              {!isManualAddress ? (
                <Form.Control
                  type="text"
                  name="country"
                  placeholder="Auto-populated from address search"
                  readOnly
                  disabled
                  value={basicDetails?.country || ""}
                  className={
                    (!basicDetails?.country && skipButtonClicked) ||
                      isWarning(fields_to_improve, "country")
                      ? "warning-field"
                      : ""
                  }
                />
              ) : (
                <Select1
                  options={countryOptions}
                  placeholder="Select country"
                  value={
                    basicDetails?.country
                      ? { label: basicDetails.country, value: basicDetails.country }
                      : null
                  }
                  onChange={(selected: any) =>
                    handleChange("country", selected?.value || "")
                  }
                  className={
                    (!basicDetails?.country && skipButtonClicked) ||
                    isWarning(fields_to_improve, "country")
                      ? "warning-field"
                      : ""
                  }
                />
              )}
              <ErrorComponent
                title="Please enter country"
                flag={errorFlag && !skipButtonClicked}
                isArray={false}
                data={basicDetails?.country}
              />
            </div>
          </div>
          <div className="d-flex w-100 gap-1">
            <div className="w-50">
              <RequiredLabel isRequired={false}>Pincode</RequiredLabel>
              <Form.Control
                type="text"
                name="pincode"
                placeholder="Enter Pincode"
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
                className={
                  isWarning(fields_to_improve, "pincode") ? "warning-field" : ""
                }
                value={basicDetails?.pincode}
              />
            </div>
            <div className="w-50">
              <RequiredLabel isRequired={false}>
                Year Of Establishment
              </RequiredLabel>
              <DatePicker
                selected={
                  basicDetails?.year_of_establishment
                    ? new Date(`${basicDetails?.year_of_establishment}-01-01`)
                    : null
                }
                wrapperClassName="w-100"
                onChange={handleYearChange}
                showYearPicker
                dateFormat="yyyy"
                minDate={new Date("1900-01-01")}
                maxDate={new Date()}
                className={
                  isWarning(fields_to_improve, "year_of_establishment")
                    ? "warning-field form-control text-center w-100 "
                    : "form-control text-center w-100"
                }
                placeholderText="Select year"
                customInput={<CustomInput />}
              />

              {/* <ErrorComponent
                title="Please enter  year of establishment"
                flag={errorFlag}
                isArray={false}
                data={basicDetails?.year_of_establishment}
              /> */}
            </div>
          </div>

          <div className="mb-2 w-10">
            <RequiredLabel isRequired={true}>
              Business Sector / Industry
            </RequiredLabel>
            <div ref={controlRef}>
              <Select1
                classNamePrefix="react-select"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                }}
                isMulti
                menuPortalTarget={document.body}
                menuIsOpen={menuOpen}
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                closeMenuOnScroll={false}
                menuPosition="fixed"
                options={dropdownData[DROPDOWNTYPES.BUSINESS_INDUSTRY] || []}
                onChange={(values: any) => {
                  handleArrayValueChange(values, "business_industry");
                }}
                className={
                  (basicDetails?.business_industry?.length === 0 &&
                    skipButtonClicked) ||
                    isWarning(fields_to_improve, "business_industry")
                    ? "warning-field"
                    : ""
                }
                name="business_industry"
                value={
                  basicDetails?.business_industry?.length > 0
                    ? basicDetails?.business_industry.map((item: any) => ({
                      value: item?.title,
                      label: item?.title,
                    }))
                    : []
                }
              />
              <ErrorComponent
                title="Please enter country"
                flag={errorFlag && !skipButtonClicked}
                isArray={true}
                data={basicDetails?.business_industry}
              />
            </div>
          </div>

          {basicDetails?.business_industry?.length > 0 &&
            basicDetails?.business_industry[0]?.title === "Other" && (
              <div className="w-100">
                <RequiredLabel isRequired={true}>
                  Other Business Sector / Industry
                </RequiredLabel>

                <Form.Control
                  type="text"
                  name="other"
                  placeholder="Enter Business Sector / Industry"
                  onChange={(e) => {
                    const value = e.target.value;
                    setBasicDetails((prev: BasicDetailWantToSell) => ({
                      ...prev,
                      business_industry: [
                        {
                          ...prev.business_industry[0],
                          other: value,
                        },
                      ],
                    }));
                  }}
                  value={
                    (basicDetails?.business_industry?.[0]?.other as string) ||
                    ""
                  }
                />

                <ErrorComponent
                  title="Please enter Business Sector / Industry"
                  flag={errorFlag}
                  isArray={false}
                  data={basicDetails?.business_industry?.[0]?.other}
                />
              </div>
            )}

          <div className="mb-2 w-100">
            <RequiredLabel isRequired={true}>Ownership Type</RequiredLabel>

            <Select
              dropdownHeight="200px"
              dropdownPosition="auto"
              options={dropdownData[DROPDOWNTYPES.OWNERSHIP_TYPE] || []}
              onChange={(values: any) => {
                if (values?.length > 0) {
                  handleArrayValueChange(values, "ownership_type");
                }
              }}
              style={{ minHeight: "100px" }}
              className={
                (!basicDetails?.ownership_type && skipButtonClicked) ||
                  isWarning(fields_to_improve, "ownership_type")
                  ? "warning-field multi-select"
                  : "multi-select"
              }
              labelField="label"
              valueField="value"
              name="ownership_type"
              values={
                basicDetails?.ownership_type
                  ? [
                    {
                      value: basicDetails?.ownership_type,
                      label: basicDetails?.ownership_type,
                    },
                  ]
                  : []
              }
            />
            <ErrorComponent
              title="Please select ownership type"
              flag={errorFlag && !skipButtonClicked}
              isArray={true}
              data={basicDetails?.ownership_type}
            />
          </div>
          {basicDetails?.ownership_type === "Other" && (
            <div className="w-10">
              <RequiredLabel isRequired={true}>
                Other Ownership Type
              </RequiredLabel>

              <Form.Control
                type="text"
                name="ownership_type_other"
                placeholder="Enter other ownership type"
                onChange={(e) => {
                  const value = e.target.value;
                  setBasicDetails((prev: BasicDetailWantToSell) => ({
                    ...prev,
                    ownership_type_other: value,
                  }));
                }}
                value={basicDetails?.ownership_type_other}
              />

              <ErrorComponent
                title="Please enter other ownership type"
                flag={errorFlag}
                isArray={false}
                data={basicDetails?.ownership_type_other}
              />
            </div>
          )}

          <div className="mb-2 w-100">
            <RequiredLabel isRequired={false}>
              Company Website/Portfolio Link
            </RequiredLabel>

            <Form.Control
              type="text"
              name="company_website"
              placeholder="Enter website URL(e.g.https://example.com)"
              onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
              value={basicDetails?.company_website}
              className={
                isWarning(fields_to_improve, "company_website")
                  ? "warning-field"
                  : ""
              }
            />

            {basicDetails?.company_website &&
              !HelperService?.checkWebUrl(basicDetails?.company_website) &&
              errorFlag && (
                <Label modeError={true} title="Please enter valid link" />
              )}
          </div>
          <div className="mb-3 mt-2">
            <div className="d-flex justify-content-between">
              <div>
                <RequiredLabel isRequired={false}>
                  Brief Business Description (Problem, Solution, USP)
                </RequiredLabel>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "2px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // borderRadius: "10px",
                    // backgroundColor: "#ccc",
                    // width: "40x",
                    // height: "32px",
                    // color: "#fff",
                    fontWeight: "bold",
                    // minWidth: "40px",
                  }}
                >
                  <p className="font-10 font-bold" style={{ margin: 0 }}>
                    {basicDetails?.brief_about_business?.length || 0}/700
                  </p>
                </div>
              </div>
            </div>

            <Form.Control
              as="textarea"
              placeholder={t("Register.enter_description")}
              style={{ height: "80px" }}
              name="brief_about_business"
              maxLength={700}
              value={basicDetails?.brief_about_business}
              onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
              className={
                isWarning(fields_to_improve, "brief_about_business")
                  ? "warning-field"
                  : ""
              }
            />
          </div>

          <div className="mb-4">
            <div className="d-flex justify-content-between">
              <div>
                <RequiredLabel isRequired={false}>
                  Vision & Mission
                </RequiredLabel>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "2px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // borderRadius: "10px",
                    // backgroundColor: "#ccc",
                    // width: "40x",
                    // height: "32px",
                    // color: "#fff",
                    fontWeight: "bold",
                    // minWidth: "40px",
                  }}
                >
                  <p className="font-12 font-bold" style={{ margin: 0 }}>
                    {basicDetails?.vision_mission?.length || 0}/700
                  </p>
                </div>
              </div>
            </div>

            <Form.Control
              as="textarea"
              placeholder={t("Register.enter_description")}
              style={{ height: "80px" }}
              name="vision_mission"
              value={basicDetails?.vision_mission}
              onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
              maxLength={700}
              className={
                isWarning(fields_to_improve, "vision_mission")
                  ? "warning-field"
                  : ""
              }
            />
            {/* {errorFlag && !basicDetails?.vision_mission && (
              <Label title="Please enter vision mission" modeError={true} />
            )} */}
          </div>
          <div className="mb-4 ">
            <RequiredLabel isRequired={false}>
              Reason for Selling (Retirement, Relocation, New Venture, etc.)
            </RequiredLabel>

            <Form.Control
              as="textarea"
              placeholder="Reason for sale"
              style={{ height: "80px" }}
              name="reason_for_sale"
              value={basicDetails?.reason_for_sale}
              onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
              maxLength={500}
              className={
                isWarning(fields_to_improve, "reason_for_sale")
                  ? "warning-field"
                  : ""
              }
            />
            {/* <ErrorComponent
              title="Please enter reason for sale"
              flag={errorFlag}
              isArray={false}
              data={basicDetails?.reason_for_sale}
            /> */}
          </div>
          <div className="mb-4">
            <RequiredLabel isRequired={false}>
              Key Strengths & Differentiators
            </RequiredLabel>

            <Form.Control
              type="text"
              name="strength_differentiators"
              placeholder="Enter strength differentiators"
              onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
              value={basicDetails?.strength_differentiators}
              className={
                isWarning(fields_to_improve, "strength_differentiators")
                  ? "warning-field"
                  : ""
              }
            />
            {/* <ErrorComponent
              title="Please enter strength differentiators"
              flag={errorFlag}
              isArray={false}
              data={basicDetails?.strength_differentiators}
            /> */}
          </div>

          <div className="mb-2 d-flex gap-2">
            <Button
              className={
                from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                  ? "btn btn-primary w-100"
                  : "btn btn-primary w-50"
              }
              disabled={apiCallTriggered}
              type="button"
              id="save_basic_details"
              onClick={() => {
                setSkipButtonClicked(false);
                handleSaveBasicDetails(false);
              }}
            >
              {" "}
              {from && from === "REVIEW"
                ? t("Register.save")
                : t("Register.continue")}
            </Button>
            {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
              <Button
                className="btn btn-secondary w-50"
                type="button"
                id="skip_basic_details"
                onClick={() => {
                  setSkipButtonClicked(true);
                  handleSaveBasicDetails(true);
                }}
                disabled={apiCallTriggered}
              >
                Skip
              </Button>
            )}
          </div>
        </div>
      </CommonScrollbar>
    </div>
  </>
  );
};

export default BasicDetailsWantToSell;
